import React from 'react';
import { COLLECTION_MOCKUP } from '../data/woodworking';
interface CollectionMockupProps {
  /** Hero instance: eager + high priority (LCP). */
  priority?: boolean;
  className?: string;
}
const PAGE = 'block aspect-[1688/2184] w-full object-contain';

/**
 * Digital-collection composition built from the real files: the two finished
 * covers, page 27 on a tablet and page 28 as a printed sheet. Pages are shown
 * whole (object-contain), never cropped.
 */
export function CollectionMockup({
  priority = false,
  className = ''
}: CollectionMockupProps) {
  const {
    covers,
    tabletPage,
    sheetPage,
    label
  } = COLLECTION_MOCKUP;
  const loading = priority ? 'eager' : 'lazy';
  return <div role="img" aria-label={label} className={`relative aspect-[10/9] w-full ${className}`} data-id="element-40" data-mp="2ndr82n6bk63o">
      {/* Volume covers */}
      <div className="absolute left-[1%] top-[4%] w-[37%] -rotate-[7deg] overflow-hidden rounded-[3px] bg-black shadow-[0_24px_40px_-18px_rgba(0,0,0,0.75)] ring-1 ring-white/20" data-id="element-41" data-mp="29dzq6bcom5ke">
        <img src={covers[0].src} alt="" width={covers[0].width} height={covers[0].height} loading={loading} decoding="async" className={PAGE} data-id="element-42" data-mp="3vf6embk1k9fx" />
      </div>
      <div className="absolute left-[20%] top-0 w-[37%] -rotate-[2deg] overflow-hidden rounded-[3px] bg-black shadow-[0_28px_44px_-18px_rgba(0,0,0,0.8)] ring-1 ring-white/20" data-id="element-43" data-mp="3qgbo0nfu1gl9">
        <img src={covers[1].src} alt="" width={covers[1].width} height={covers[1].height} loading={loading} decoding="async" className={PAGE} data-id="element-44" data-mp="3d6stxu0w4zv" />
      </div>

      {/* Printed sheet: exploded view & cut list */}
      <div className="absolute bottom-[1%] left-[9%] z-10 w-[40%] -rotate-[4deg] bg-paper p-[1.2%] shadow-[0_30px_50px_-20px_rgba(0,0,0,0.85)]" data-id="element-45" data-mp="37rok489e6x99">
        <img src={sheetPage.src} alt="" width={sheetPage.width} height={sheetPage.height} loading={loading} decoding="async" className={PAGE} data-id="element-46" data-mp="3gr1ud35cbpv1" />
      </div>

      {/* Tablet: dimensioned plans */}
      <div className="absolute right-[1%] top-[9%] z-20 w-[52%] rotate-[3deg] rounded-[14px] bg-[#0E0F10] p-[3%] shadow-[0_40px_60px_-24px_rgba(0,0,0,0.9)] ring-1 ring-white/15 sm:rounded-[22px]" data-id="element-47" data-mp="2o24et7sik75z">
        <div className="overflow-hidden rounded-[4px] bg-black" data-id="element-48" data-mp="wy2oj1i9jcyn">
          <img src={tabletPage.src} alt="" width={tabletPage.width} height={tabletPage.height} loading={loading} fetchPriority={priority ? 'high' : 'auto'} decoding="async" className={PAGE} data-id="element-49" data-mp="ww873x67a2zb" />
        </div>
      </div>
    </div>;
}